import route from '@H/route';
import router from '@R';
import axios from 'axios';
import store from '@VX/store';

export default {
    mustBeVerified(user, next = router.push) {
        next({
            name: 'verify-account',
            params: {
                email: user.email
            }
        });
    },
    mustHaveFinishedEnrolment(user, next = router.push) {
        return next({
            name: 'begin-enrolment'
        });
    },
    setupRegister(salesforceAccount) {
        store.commit('Auth/firstName', salesforceAccount.first_name, { root: true });
        store.commit('Auth/lastName', salesforceAccount.last_name, { root: true });
        store.commit('Auth/salutation', salesforceAccount.salutation, { root: true });
        store.commit('Auth/password', '');
        store.commit('setFormSubmitting', false, { root: true });

        // Update the language in vue and against the user.
        store.commit('Auth/language', salesforceAccount.language, { root: true });
        store.dispatch('setLanguage', salesforceAccount.language, { root: true });

        return router.push({ name: 'register' });
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/user.js